var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",style:({
    fontSize: _vm.size + 'px',
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    color: _vm.color
  }),on:{"click":function($event){return _vm.$emit('click')}}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})])
}
var staticRenderFns = []

export { render, staticRenderFns }